import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d85b84f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5d85b84f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85b84f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d85b84f')) {
      api.createRecord('5d85b84f', component.options)
    } else {
      api.reload('5d85b84f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d85b84f&scoped=true", function () {
      api.rerender('5d85b84f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/takeMedicine/index.vue"
export default component.exports